<ng-content></ng-content>
<span class="invalid-icon"></span>
